import React from "react";

const EditIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.82353 5.26367H2.88236C2.38312 5.26367 1.90434 5.46199 1.55133 5.815C1.19832 6.16801 1 6.6468 1 7.14603V15.6166C1 16.1159 1.19832 16.5946 1.55133 16.9477C1.90434 17.3007 2.38312 17.499 2.88236 17.499H11.353C11.8522 17.499 12.331 17.3007 12.684 16.9477C13.037 16.5946 13.2353 16.1159 13.2353 15.6166V14.6755"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.294 3.38246L15.1175 6.20599M16.4211 4.87422C16.7917 4.50354 17 4.00079 17 3.47657C17 2.95235 16.7917 2.4496 16.4211 2.07893C16.0504 1.70825 15.5476 1.5 15.0234 1.5C14.4992 1.5 13.9964 1.70825 13.6258 2.07893L5.70575 9.9707V12.7942H8.52928L16.4211 4.87422Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
